import { Button } from "@mui/material"
import { useGetIdentity, useGetOne, useNotify, useRecordContext, useRedirect, useTranslate } from "react-admin"
import { InvoiceReadModel, InvoiceReminderReadModel, SendInvoiceReminderByMailCommand, UserReadModel } from "../../GeneratedClients/FreeBillApi"
import SendEmailDialog from "../../emails/actionDialogs/SendEmailDialog"
import { useState } from "react"
import { useMutation } from "react-query";
import { apiService } from "../../apiService"
import validateEmail from "../../emails/validateEmail"
import MailValidationFailedDialog from "../../emails/actionDialogs/MailValidationFailedDialog"

const SendInvoiceReminderButton = () => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  //@ts-ignore
  const { data: user, isLoading: userLoading} = useGetOne<UserReadModel>("users", {id: identity?.id}, {enabled: !identityLoading})
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const invoiceReminder = useRecordContext<InvoiceReminderReadModel>()
  //@ts-ignore
  const {data: invoice} = useGetOne<InvoiceReadModel>("invoices", {id: invoiceReminder.invoiceId})
  const [open, setOpen] = useState<boolean>(false)
  const { mutate, isLoading } = useMutation((command: SendInvoiceReminderByMailCommand) => 
    apiService.InvoiceRemindersApi.sendInvoiceReminder({sendInvoiceReminderByMailCommand: command, id: command.id!}),
    {
      onSuccess: (data) => {
        notify(translate("resources.invoices.notifications.invoiceReminderSent"))
        redirect('list', 'invoiceReminders')
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const record: SendInvoiceReminderByMailCommand = {
    id: invoiceReminder?.id, 
    invoiceId: invoiceReminder?.invoiceId,
    fromAddress: user?.mailServiceConfig?.email,
    fromName: user?.mailServiceConfig?.sender,
    toAddresses: invoiceReminder?.invoiceRecipient?.company?.email ? [invoiceReminder?.invoiceRecipient?.company?.email] : undefined,
    toName: invoiceReminder?.invoiceRecipient?.company?.companyName,
    subject: invoiceReminder?.textModel?.heading,
    emailText: invoiceReminder?.textModel?.introduction, 
    userId: invoiceReminder?.userId
  }

  const handleSubmit = (command: SendInvoiceReminderByMailCommand) => {
    mutate(command)
  }

  const emailValidation = validateEmail(user?.mailServiceConfig)

  if(!invoiceReminder || identityLoading || userLoading) return null

  return (
    <>
      <Button
        onClick={handleOpen}
        size="small"
      >
        {translate('resources.invoices.actions.send')}
      </Button>

      {
        !emailValidation.isValid ? (
          <MailValidationFailedDialog 
            message={emailValidation.message} 
            actionButtonText={emailValidation.actionButtonText} 
            open={open}
            handleClose={handleClose}
          />
        ) : (
          <SendEmailDialog 
            record={record} 
            handleSubmit={handleSubmit} 
            attachments={[
              {
                attachmentFileName: `${invoiceReminder?.textModel?.heading}.pdf`,
                resource: "invoiceReminders",
                id: invoiceReminder.id
              },
              {
                attachmentFileName: `${invoice?.textModel?.heading}.pdf`,
                resource: "invoices",
                id: invoiceReminder.invoiceId
              },
            ]}
            isLoading={isLoading} 
            resource='invoiceReminders'
            dialogText={translate("resources.invoices.dialogs.sendInvoiceReminder")}
            open={open}
            handleClose={handleClose}   
          />
        )
      }
    </>
  )
}

export default SendInvoiceReminderButton